module.exports = __webpack_public_path__ + "img/shopping-cart.d172fc30.svg";